import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  scrollBox: {
    height: `calc(100vh - 64px)`,
    display: 'flex',
    flexDirection: 'column',
  },
  tableContainer: {
    flex: '1 1 auto',
    margin: `0  ${theme.spacing(3)}`,
    padding: `0  0 ${theme.spacing(3)}`,
    overflowY: 'hidden',
  },
  button: {
    padding: '0.3rem 1rem',
    fontSize: '12px',
  },
  buttonMarginRight: {
    marginRight: theme.spacing(1)
  },
  buttonMargin: {
    margin: '0 12px',
  },
  marginLeftAuto: {
    marginLeft: 'auto',
  },
  inButtonIcon: {
    marginLeft: theme.spacing(1),
  },
  uploadButtonIcon: {
    marginRight: theme.spacing(1),
  },
  count: {
    margin: `0 ${theme.spacing(2)}`,
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.grey[300]} `,
    width: '100%',
    fontSize: '20px',
  },
  directionalBreakpointSwitch: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
  select: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    textOverflow: 'ellipsis',
  },
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  modemTableContainer: {
    height: '320px',
    marginTop: '10px'
  },
  overFlowEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  iconButton: {
    padding: 0,
  },
}));

export default useStyles;
